export default __webpack_public_path__ + "static/media/logo.16d243d6.png";